// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const RejectionErrorsPanelV2ModalTriggerText = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.rejectionErrors.rejectionErrorsPanelV2ModalTriggerText"
        description="Rejection errors panel v2 modal trigger text."
        defaultMessage="Error Logs"
    />
);
RejectionErrorsPanelV2ModalTriggerText.displayName = "RejectionErrorsPanelV2ModalTriggerText";

export const RejectionErrorsPanelV2Message = (props: { rejectionErrorsModalWithTrigger: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.rejectionErrors.rejectionErrorsPanelV2Message"
        description="Rejection errors panel v2 message."
        defaultMessage="This Lens submission was rejected due to technical errors, please check {rejectionErrorsModalWithTrigger} and update your lens accordingly."
        values={props}
    />
);
RejectionErrorsPanelV2Message.displayName = "RejectionErrorsPanelV2Message";

export const SubmissionErrorsPanelV2Message = (props: { rejectionErrorsModalWithTrigger: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.lensSource.rejectionErrors.submissionErrorsPanelV2Message"
        description="Submission errors panel v2 message."
        defaultMessage="This Lens submission contains technical errors, please check {rejectionErrorsModalWithTrigger} and update your lens accordingly."
        values={props}
    />
);
SubmissionErrorsPanelV2Message.displayName = "SubmissionErrorsPanelV2Message";
